import CryptoJS from 'crypto-js';
import { ROLES, ROLE_LABELS, SECRET_ENCRYPTION_KEY } from './constants';


// Save encrypted value of a key
export const encryptKeyValue = (key, value) => {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value); // Convert array/object to string
    const encryptedValue = CryptoJS.AES.encrypt(stringValue, SECRET_ENCRYPTION_KEY).toString();
    localStorage.setItem(key, encryptedValue);
};


// get decryptKeyValue value of a key
export const decryptKeyValue = (key) => {
    const encryptedKeyValue = localStorage.getItem(key);
    if (encryptedKeyValue) {
        const bytes = CryptoJS.AES.decrypt(encryptedKeyValue, SECRET_ENCRYPTION_KEY);
        const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
        try {
            // Try to parse the decrypted value back into an object/array
            return JSON.parse(decryptedValue);
        } catch (e) {
            // If parsing fails, it's likely a simple string, so return as-is
            return decryptedValue;
        }
    }
    return null;
};

export const convertToAmPm = (slot, onlyStartTime = false) => {
    const [start, end] = slot.split(" - ");
    const convert = (time) => {
        const [hour, minute] = time.split(":");
        const h = parseInt(hour, 10);
        const period = h >= 12 ? "PM" : "AM";
        const formattedHour = h % 12 || 12; // Convert 0 to 12 for 12-hour format
        return `${formattedHour}:${minute} ${period}`;
    };

    if (onlyStartTime) {
        return convert(start);
    }
    return `${convert(start)} - ${convert(end)}`;
};


export const normalizePermissions = (permissions) => {
    return Object.keys(permissions).reduce((acc, key) => {
        const normalizedKey = key.toUpperCase();
        acc[normalizedKey] = permissions[key];
        return acc;
    }, {});
};

export const capitalizeWords = (text) => {
    return text
        .toLowerCase()
        .replace(/_/g, ' ') // Replace underscores with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
};



export const routes = {


    home: '/',
    news: '/news',
    portfolio: '/portfolio',
    dashboard: '/dashboard',
    signal: '/trading-signals',
    learning_hub: '/learning-hub',
    whale_tracker: '/whale-tracker',
    calendar_event: '/events',
    affiliate: '/affiliate',


    guide: '/crm/guide',
    reviews: '/crm/reviews',
    review_detail: '/crm/reviews/:id',
    walker: '/crm/walker',
    order: '/crm/order',
    order_detail: '/crm/order/:id?',
    user: '/crm/user',
    user_detail: '/crm/user/:email?',
    organizers: '/crm/organizers',
    organizer_detail: '/crm/organizers/:id',
    parents: '/crm/parents',
    children: '/crm/children',
    assistant_admins: '/crm/assistant-admins',
    activities: '/activities',
    organizer_activities: '/organizer/activities',
    organizer_activity_new: '/organizer/activities/new',
    organizer_activity_edit: '/organizer/activities/:id/edit',
    organizer_notifications: '/organizer/notifications',
    admin_activity_new: '/crm/activities/new',
    admin_activity_edit: '/crm/activities/:id/edit',
    pet: '/crm/pet',
    walk: '/crm/paw-walk',
    walk_single: '/crm/paw-walk/:walk_id?',
    delivery: '/crm/paw-taxi',
    delivery_single: '/crm/paw-taxi/:delivery_id?',

    // Bookings
    bookings: '/crm/bookings',
    admin_bookings: '/crm/bookings',
    organizer_bookings: '/crm/organizer/bookings',
    booking_detail: '/crm/bookings/:id?',

    // Commissions
    commissions: '/crm/commissions',

    // Payout Requests
    payout_requests: '/crm/payout-requests',

    // Fees & Deductions (organizer)
    fees_deductions: '/crm/fees-deductions',

    profile: '/profile/:username?',
    payment_success: '/payment/success',
    payment_failed: '/payment/failed',

    // setting
    setting: '/crm/setting',
    membership: '/crm/setting/membership',
    promo_code: '/crm/setting/promo-code',
    role: '/crm/setting/role',
    permission: '/crm/setting/permission',
    article: '/crm/setting/articles',
    allergy: '/crm/setting/allergy',
    interest: '/crm/setting/interest',
    activity_category: '/crm/setting/activity-category',
    personality_trait: '/crm/setting/personality-trait',
    queries: '/crm/setting/queries',
    organizer_onboarding: '/onboarding/organizer',


    pet_type: '/crm/setting/pet-type',
    pet_breed: '/crm/setting/pet-breed',
    pet_allergy: '/crm/setting/pet-allergy',
    walk_tool: '/crm/setting/walk-tool',
    partner: '/crm/setting/partner',


    // Auth
    login: '/auth/login',
    registration: '/auth/registration',
    verify: '/auth/verify-account',
    forgot_password: '/auth/forgot-password',
    reset_password: '/auth/reset-password',


    // policy
    terms: '/terms',
    privacy_policy: '/privacy-policy',
    eula: '/end-user-license-agreement',
  contact: '/contact',

    // error
    403: '/access-denied',
};

const CRM_ROLE_PRIORITY = [ROLES.ADMIN, ROLES.ASSISTANT_ADMIN, ROLES.ORGANIZER];

export const getDefaultRouteForRoles = (roles = []) => {
  if (!Array.isArray(roles) || roles.length === 0) {
    return routes.dashboard;
  }
  if (roles.includes(ROLES.ASSISTANT_ADMIN) && !roles.includes(ROLES.ADMIN)) {
    return routes.bookings;
  }
  return routes.dashboard;
};

export const getRoleDisplayLabel = (roles = []) => {
  if (!Array.isArray(roles)) return '';
  const primary = CRM_ROLE_PRIORITY.find((r) => roles.includes(r));
  return primary ? ROLE_LABELS[primary] ?? primary : '';
};

export const isSupportAdminOnly = (roles = []) =>
  roles.includes(ROLES.ASSISTANT_ADMIN) && !roles.includes(ROLES.ADMIN);

